/* eslint-disable */
// DnaConfirm — small DNA-styled modal-on-modal confirm, rendered as a direct
// child of DnaModalShell's .card (covers the whole modal). Used for the
// unsaved-changes dirty guard. Its own scrim/ESC must NOT cascade-close the
// parent: the scrim stops mouse propagation so the parent backdrop's
// mousedown-origin guard never fires, and ESC is owned by DnaModalShell
// (it routes ESC to "keep editing" while this is open).
import React from 'react';
import styles from './DnaConfirm.module.css';

export default function DnaConfirm({
  title = 'Discard unsaved changes?',
  message = 'Your entered data will be lost.',
  discardLabel = 'Discard',
  keepLabel = 'Keep editing',
  onDiscard,
  onCancel,
}) {
  return (
    <div
      className={styles.scrim}
      onMouseDown={(e) => { e.stopPropagation(); if (e.target === e.currentTarget) onCancel && onCancel(); }}
      onMouseUp={(e) => e.stopPropagation()}
    >
      <div className={styles.box} role="alertdialog" aria-label={title} onMouseDown={(e) => e.stopPropagation()}>
        <div className={styles.icon} aria-hidden="true">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 9v4" /><path d="M12 17h.01" /><path d="M10.3 3.6 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.6a2 2 0 0 0-3.4 0z" />
          </svg>
        </div>
        <div className={styles.title}>{title}</div>
        <div className={styles.msg}>{message}</div>
        <div className={styles.btns}>
          <button type="button" className={styles.keep} onClick={onCancel}>{keepLabel}</button>
          <button type="button" className={styles.discard} onClick={onDiscard}>{discardLabel}</button>
        </div>
      </div>
    </div>
  );
}
